/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons
   Note that you add the icons in camelCase in main.ts but in kebab-case in .vue.
*/
import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpRight,
  faPlus,
  faBars,
  faBookOpen,
  faBookmark,
  faCalendar,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCircleQuestion,
  faCircleXmark,
  faCity,
  faCloudArrowDown,
  faCloudArrowUp,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileLines,
  faFilter,
  faFilters,
  faHeadphones,
  faHouse,
  faImage,
  faLocationDot,
  faLockOpen,
  faMagnifyingGlass,
  faNewspaper,
  faPaperclip,
  faPaperclipVertical,
  faPencil,
  faPhone,
  faScrewdriverWrench,
  faStar,
  faUser,
  faUsers,
  faVideo,
  faVolume,
  faPause,
  faXmark,
  faX,
  faRotate,
  faFilePen,
  faEllipsisVertical,
  faFile,
  faTrash,
  faCopy,
  faFileWord,
  faFileUser,
  faArrowRightArrowLeft,
  faNarwhal,
  faUnicorn,
  faFeatherAlt,
  faDragon,
  faPaw,
  faCommentLines,
  faCheckCircle,
  faListCheck,
  faBookOpenCover,
  faCalendarDays,
  faFolderMagnifyingGlass,
  faBold,
  faItalic,
  faUnderline,
  faList,
  faChalkboardUser,
  faPen,
  faFloppyDisk,
  faFolder,
  faBriefcase,
  faStars,
  faSliders,
  faPenToSquare,
  faFileMagnifyingGlass,
  faRepeat,
  faGlobe,
  faGear,
  faBell,
  faUserLock,
  faAddressBook,
  faAngleRight,
  faArrowRightToBracket,
  faTruckFast,
  faLink,
  faIdCard,
  faChartNetwork,
  faHandshake,
  faBicycle,
  faGripDotsVertical
} from '@fortawesome/pro-light-svg-icons'

import {
  faBookmark as fasBookmark,
  faCircleCheck as fasCircleCheck,
  faEllipsis as fasEllipsis,
  faPen as fasPen,
  faXmark as fasMark
} from '@fortawesome/free-solid-svg-icons'

import { faLinkedinIn as fabLinkedin } from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add(
  faArrowRightToBracket,
  faAngleRight,
  faAddressBook,
  faUserLock,
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowUpRight,
  faPlus,
  faBars,
  faBookOpen,
  faBookmark,
  faCalendar,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faCheck,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faCircleQuestion,
  faCircleXmark,
  faCity,
  faCloudArrowDown,
  faCloudArrowUp,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFileLines,
  faFilter,
  faFilters,
  faHeadphones,
  faHouse,
  faImage,
  faLocationDot,
  faLockOpen,
  faMagnifyingGlass,
  faNewspaper,
  faPaperclip,
  faPaperclipVertical,
  faPencil,
  faPen,
  faPhone,
  faFilePen,
  faScrewdriverWrench,
  faStar,
  faUser,
  faUsers,
  faVideo,
  faVolume,
  faPause,
  faX,
  faXmark,
  fabLinkedin,
  fasBookmark,
  fasCircleCheck,
  fasEllipsis,
  faPlus,
  faRotate,
  faEllipsisVertical,
  faFile,
  faTrash,
  faCopy,
  faFileWord,
  faFileLines,
  faFileUser,
  faArrowRightArrowLeft,
  faNarwhal,
  faUnicorn,
  faFeatherAlt,
  faDragon,
  faPaw,
  faCommentLines,
  faCheckCircle,
  faListCheck,
  faBookOpenCover,
  faCalendarDays,
  faFolderMagnifyingGlass,
  faBold,
  faItalic,
  faUnderline,
  faList,
  faChalkboardUser,
  fasPen,
  faFloppyDisk,
  faFolder,
  faBriefcase,
  faStars,
  faSliders,
  faPenToSquare,
  faFileMagnifyingGlass,
  faRepeat,
  faGlobe,
  faGear,
  faBell,
  faTruckFast,
  faLink,
  faIdCard,
  faChartNetwork,
  faHandshake,
  faBicycle,
  faGripDotsVertical,
  faGear,
  fasMark
)

// Export the FontAwesomeIcon component for use in your app
export { FontAwesomeIcon }
